// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/style/createField.css */

/* Общие стили для страницы */
.create-field-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #1a0a2e; /* Очень темный фиолетовый фон */
  color: #e0e0e0; /* Светлый текст для контраста */
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Современный шрифт */
  padding: 20px;
  box-sizing: border-box;
}

/* Стили для заголовка страницы */
.create-field-header {
  display: flex;
  justify-content: space-between; /* Распределяет элементы по краям */
  align-items: center; /* Выравнивает по центру по вертикали */
  margin-bottom: 40px;
  padding-top: 30px;
  width: 100%;
  max-width: 900px; /* Ограничиваем ширину хедера */
  margin-left: auto;
  margin-right: auto;
}

.create-field-header .page-title {
  font-size: 2.8em;
  color: #9370DB; /* MediumPurple */
  text-shadow: 0 0 15px rgba(147, 112, 219, 0.6); /* Легкое свечение */
  letter-spacing: 1.5px;
  margin: 0; /* Убираем стандартные отступы */
}

/* Кнопка "Мой Профиль" */
.profile-button {
  background: linear-gradient(45deg, #7B68EE, #8A2BE2); /* Градиент от MediumSlateBlue до BlueViolet */
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(138, 43, 226, 0.3); /* Тень */
}

.profile-button:hover {
  background: linear-gradient(45deg, #8A2BE2, #7B68EE); /* Инвертированный градиент при наведении */
  transform: translateY(-2px); /* Легкий подъем */
  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.5); /* Усиленная тень */
}

.profile-button:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(138, 43, 226, 0.2);
}

/* Основное содержимое страницы (форма) */
.create-field-main-content {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
}

/* Контейнер формы */
.create-field-form {
  background: #2a104e; /* Чуть светлее фон для формы */
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 0 30px rgba(138, 43, 226, 0.4); /* Фиолетовое свечение вокруг формы */
  width: 100%;
  max-width: 450px; /* Ограничиваем ширину формы */
  display: flex;
  flex-direction: column;
  gap: 25px;
  border: 1px solid rgba(138, 43, 226, 0.3);
}

/* Группа полей ввода (label + input) */
.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 1.1em;
  margin-bottom: 8px;
  color: #B2A4D4; /* Светло-фиолетовый для меток */
  font-weight: 500;
}

.form-group input {
  padding: 14px 18px;
  border: 1px solid #5a2e8c; /* Темно-фиолетовая рамка */
  border-radius: 8px;
  background-color: #3a156e; /* Еще более темный фон для инпутов */
  color: #e0e0e0;
  font-size: 1.05em;
  outline: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.form-group input::placeholder {
  color: #9987B5;
  opacity: 0.7;
}

.form-group input:focus {
  border-color: #8A2BE2; /* BlueViolet при фокусе */
  box-shadow: 0 0 12px rgba(138, 43, 226, 0.6);
  background-color: #4a1c8c;
}

/* Кнопка "Создать Поле" */
.create-button {
  background: linear-gradient(45deg, #8A2BE2, #7B68EE);
  color: white;
  padding: 15px 25px;
  border: none;
  border-radius: 10px;
  font-size: 1.2em;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.4);
  margin-top: 20px;
}

.create-button:hover {
  background: linear-gradient(45deg, #7B68EE, #8A2BE2);
  transform: translateY(-3px);
  box-shadow: 0 12px 25px rgba(138, 43, 226, 0.6);
}

.create-button:active {
  transform: translateY(0);
  box-shadow: 0 4px 10px rgba(138, 43, 226, 0.3);
}

/* Сообщение об ошибке */
.error-message {
  color: #FF6347; /* Tomato - яркий красный */
  background-color: rgba(255, 99, 71, 0.15);
  border: 1px solid #FF6347;
  padding: 10px 15px;
  border-radius: 8px;
  margin-bottom: 15px;
  font-size: 0.95em;
  text-align: center;
}

/* Адаптивность для мобильных устройств */
@media (max-width: 600px) {
  .create-field-page {
    padding: 10px;
  }

  .create-field-header {
    flex-direction: column; /* Элементы хедера в столбец */
    gap: 15px; /* Промежуток между заголовком и кнопкой */
    text-align: center;
  }

  .create-field-header .page-title {
    font-size: 2em;
  }

  .profile-button {
    width: 100%; /* Кнопка занимает всю ширину */
    max-width: 200px; /* Ограничиваем ширину */
    margin: 0 auto; /* Центрируем */
  }

  .create-field-form {
    padding: 25px;
    gap: 18px;
  }

  .form-group input,
  .create-button {
    padding: 12px 15px;
    font-size: 1em;
  }

  .form-group label {
    font-size: 1em;
  }
    .header-buttons {
    flex-direction: column; /* Кнопки в столбец */
    width: 100%; /* Занимают всю ширину */
  }

  /* НОВЫЕ СТИЛИ: Кнопки "Мой Профиль" и "Главная Страница" на мобильных */
  .profile-button,
  .home-button {
    width: 100%; /* Каждая кнопка занимает всю доступную ширину контейнера */
    max-width: 200px; /* Ограничиваем ширину для эстетики */
    margin: 0 auto; /* Центрируем кнопки */
  }
}

.header-buttons {
  display: flex;
  gap: 15px; /* Пространство между кнопками */
  align-items: center;
}

/* НОВЫЕ СТИЛИ: Кнопка "Главная Страница" */
.home-button {
  background: linear-gradient(45deg, #A779E1, #B58AE2); /* Более светлый фиолетовый градиент */
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(167, 121, 225, 0.3); /* Тень, соответствующая градиенту */
}

.home-button:hover {
  background: linear-gradient(45deg, #B58AE2, #A779E1); /* Инвертированный градиент при наведении */
  transform: translateY(-2px); /* Легкий подъем */
  box-shadow: 0 8px 20px rgba(167, 121, 225, 0.5); /* Усиленная тень */
}

.home-button:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(167, 121, 225, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/style/createField.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB,EAAE,gCAAgC;EACrD,cAAc,EAAE,gCAAgC;EAChD,4DAA4D,EAAE,sBAAsB;EACpF,aAAa;EACb,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B,EAAE,mCAAmC;EACnE,mBAAmB,EAAE,uCAAuC;EAC5D,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,gBAAgB,EAAE,+BAA+B;EACjD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,iBAAiB;EACjC,8CAA8C,EAAE,oBAAoB;EACpE,qBAAqB;EACrB,SAAS,EAAE,gCAAgC;AAC7C;;AAEA,yBAAyB;AACzB;EACE,oDAAoD,EAAE,8CAA8C;EACpG,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C,EAAE,SAAS;AAC3D;;AAEA;EACE,oDAAoD,EAAE,2CAA2C;EACjG,2BAA2B,EAAE,kBAAkB;EAC/C,8CAA8C,EAAE,mBAAmB;AACrE;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA,yCAAyC;AACzC;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB,EAAE,+BAA+B;EACpD,aAAa;EACb,mBAAmB;EACnB,4CAA4C,EAAE,qCAAqC;EACnF,WAAW;EACX,gBAAgB,EAAE,8BAA8B;EAChD,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAE,gCAAgC;EAChD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,2BAA2B;EACtD,kBAAkB;EAClB,yBAAyB,EAAE,qCAAqC;EAChE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB,EAAE,0BAA0B;EACjD,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA,wBAAwB;AACxB;EACE,cAAc,EAAE,2BAA2B;EAC3C,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB,EAAE,8BAA8B;IACtD,SAAS,EAAE,0CAA0C;IACrD,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,gBAAgB,EAAE,wBAAwB;IAC1C,cAAc,EAAE,eAAe;EACjC;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;;IAEE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;IACE;IACA,sBAAsB,EAAE,qBAAqB;IAC7C,WAAW,EAAE,wBAAwB;EACvC;;EAEA,wEAAwE;EACxE;;IAEE,WAAW,EAAE,2DAA2D;IACxE,gBAAgB,EAAE,qCAAqC;IACvD,cAAc,EAAE,sBAAsB;EACxC;AACF;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,gCAAgC;EAC3C,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,oDAAoD,EAAE,sCAAsC;EAC5F,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+CAA+C,EAAE,oCAAoC;AACvF;;AAEA;EACE,oDAAoD,EAAE,2CAA2C;EACjG,2BAA2B,EAAE,kBAAkB;EAC/C,+CAA+C,EAAE,mBAAmB;AACtE;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;AACjD","sourcesContent":["/* src/pages/style/createField.css */\n\n/* Общие стили для страницы */\n.create-field-page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #1a0a2e; /* Очень темный фиолетовый фон */\n  color: #e0e0e0; /* Светлый текст для контраста */\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Современный шрифт */\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Стили для заголовка страницы */\n.create-field-header {\n  display: flex;\n  justify-content: space-between; /* Распределяет элементы по краям */\n  align-items: center; /* Выравнивает по центру по вертикали */\n  margin-bottom: 40px;\n  padding-top: 30px;\n  width: 100%;\n  max-width: 900px; /* Ограничиваем ширину хедера */\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.create-field-header .page-title {\n  font-size: 2.8em;\n  color: #9370DB; /* MediumPurple */\n  text-shadow: 0 0 15px rgba(147, 112, 219, 0.6); /* Легкое свечение */\n  letter-spacing: 1.5px;\n  margin: 0; /* Убираем стандартные отступы */\n}\n\n/* Кнопка \"Мой Профиль\" */\n.profile-button {\n  background: linear-gradient(45deg, #7B68EE, #8A2BE2); /* Градиент от MediumSlateBlue до BlueViolet */\n  color: white;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1em;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 15px rgba(138, 43, 226, 0.3); /* Тень */\n}\n\n.profile-button:hover {\n  background: linear-gradient(45deg, #8A2BE2, #7B68EE); /* Инвертированный градиент при наведении */\n  transform: translateY(-2px); /* Легкий подъем */\n  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.5); /* Усиленная тень */\n}\n\n.profile-button:active {\n  transform: translateY(0);\n  box-shadow: 0 3px 10px rgba(138, 43, 226, 0.2);\n}\n\n/* Основное содержимое страницы (форма) */\n.create-field-main-content {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px 0;\n}\n\n/* Контейнер формы */\n.create-field-form {\n  background: #2a104e; /* Чуть светлее фон для формы */\n  padding: 40px;\n  border-radius: 15px;\n  box-shadow: 0 0 30px rgba(138, 43, 226, 0.4); /* Фиолетовое свечение вокруг формы */\n  width: 100%;\n  max-width: 450px; /* Ограничиваем ширину формы */\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  border: 1px solid rgba(138, 43, 226, 0.3);\n}\n\n/* Группа полей ввода (label + input) */\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  font-size: 1.1em;\n  margin-bottom: 8px;\n  color: #B2A4D4; /* Светло-фиолетовый для меток */\n  font-weight: 500;\n}\n\n.form-group input {\n  padding: 14px 18px;\n  border: 1px solid #5a2e8c; /* Темно-фиолетовая рамка */\n  border-radius: 8px;\n  background-color: #3a156e; /* Еще более темный фон для инпутов */\n  color: #e0e0e0;\n  font-size: 1.05em;\n  outline: none;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.form-group input::placeholder {\n  color: #9987B5;\n  opacity: 0.7;\n}\n\n.form-group input:focus {\n  border-color: #8A2BE2; /* BlueViolet при фокусе */\n  box-shadow: 0 0 12px rgba(138, 43, 226, 0.6);\n  background-color: #4a1c8c;\n}\n\n/* Кнопка \"Создать Поле\" */\n.create-button {\n  background: linear-gradient(45deg, #8A2BE2, #7B68EE);\n  color: white;\n  padding: 15px 25px;\n  border: none;\n  border-radius: 10px;\n  font-size: 1.2em;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.4);\n  margin-top: 20px;\n}\n\n.create-button:hover {\n  background: linear-gradient(45deg, #7B68EE, #8A2BE2);\n  transform: translateY(-3px);\n  box-shadow: 0 12px 25px rgba(138, 43, 226, 0.6);\n}\n\n.create-button:active {\n  transform: translateY(0);\n  box-shadow: 0 4px 10px rgba(138, 43, 226, 0.3);\n}\n\n/* Сообщение об ошибке */\n.error-message {\n  color: #FF6347; /* Tomato - яркий красный */\n  background-color: rgba(255, 99, 71, 0.15);\n  border: 1px solid #FF6347;\n  padding: 10px 15px;\n  border-radius: 8px;\n  margin-bottom: 15px;\n  font-size: 0.95em;\n  text-align: center;\n}\n\n/* Адаптивность для мобильных устройств */\n@media (max-width: 600px) {\n  .create-field-page {\n    padding: 10px;\n  }\n\n  .create-field-header {\n    flex-direction: column; /* Элементы хедера в столбец */\n    gap: 15px; /* Промежуток между заголовком и кнопкой */\n    text-align: center;\n  }\n\n  .create-field-header .page-title {\n    font-size: 2em;\n  }\n\n  .profile-button {\n    width: 100%; /* Кнопка занимает всю ширину */\n    max-width: 200px; /* Ограничиваем ширину */\n    margin: 0 auto; /* Центрируем */\n  }\n\n  .create-field-form {\n    padding: 25px;\n    gap: 18px;\n  }\n\n  .form-group input,\n  .create-button {\n    padding: 12px 15px;\n    font-size: 1em;\n  }\n\n  .form-group label {\n    font-size: 1em;\n  }\n    .header-buttons {\n    flex-direction: column; /* Кнопки в столбец */\n    width: 100%; /* Занимают всю ширину */\n  }\n\n  /* НОВЫЕ СТИЛИ: Кнопки \"Мой Профиль\" и \"Главная Страница\" на мобильных */\n  .profile-button,\n  .home-button {\n    width: 100%; /* Каждая кнопка занимает всю доступную ширину контейнера */\n    max-width: 200px; /* Ограничиваем ширину для эстетики */\n    margin: 0 auto; /* Центрируем кнопки */\n  }\n}\n\n.header-buttons {\n  display: flex;\n  gap: 15px; /* Пространство между кнопками */\n  align-items: center;\n}\n\n/* НОВЫЕ СТИЛИ: Кнопка \"Главная Страница\" */\n.home-button {\n  background: linear-gradient(45deg, #A779E1, #B58AE2); /* Более светлый фиолетовый градиент */\n  color: white;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1em;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 15px rgba(167, 121, 225, 0.3); /* Тень, соответствующая градиенту */\n}\n\n.home-button:hover {\n  background: linear-gradient(45deg, #B58AE2, #A779E1); /* Инвертированный градиент при наведении */\n  transform: translateY(-2px); /* Легкий подъем */\n  box-shadow: 0 8px 20px rgba(167, 121, 225, 0.5); /* Усиленная тень */\n}\n\n.home-button:active {\n  transform: translateY(0);\n  box-shadow: 0 3px 10px rgba(167, 121, 225, 0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
